// preLoader
// @import "base/modules/loader";
let loader = document.querySelector('.preloader');
const loaderFunc = () => {
    document.querySelector('body').classList.add('lock');
    setTimeout(() => {
        document.querySelector('body').classList.remove('lock');
        loader.remove();
    }, 1)
}
if (document.readyState === 'complete' || document.readyState !== 'loading') {
    loaderFunc();
} else {
    window.addEventListener('load', loaderFunc);
}

import './modules/mika-moving-element.js';
import * as mod from './modules/dialog.js';
//import './modules/pwm-form-select.js';

import * as tech from './modules/tech/tech.js';
//import Modal from './modules/modal.js';
//import * as  formsOld from './modules/forms.js';
import { enableScroll, disableScroll } from './modules/tech/toggle-scroll.js';
//import * as video from './modules/video.js';
import * as die from './modules/mod/die.js';

tech.isDevice();
tech.webP();

document.addEventListener('DOMContentLoaded', () => {
    "use strict"

    window.addEventListener('scroll', () => {
        document.documentElement.style.setProperty('--scroll-y', `${window.scrollY}px`);
    });

    //movingElement();

    /********************* Lang Toggle *********************/
    const lang = document.querySelector('.lang__title');
    if (lang) {
        lang.addEventListener('click', (e) => {
            e.preventDefault;
            let cont = e.target.closest('.lang');
            if (cont) {
                cont.classList.toggle('open');
            }
        });
    }

    // go back
    const goBack = () => {
        const btn = document.querySelector('[data-goback]');
        if (btn) {
            btn.addEventListener('click', () => {
                history.back();
            });
        }
    }
    goBack();

    /** New PopUp DIALOG */

    mod.dialog();

    /********************* Animation *********************/





    /********************* Burger *********************/
    /* Burger ****
    * element burger, element menu, if (element arrow submenu)
    * die.burgerMenu('.burger', '.header__menu');
    * die.burgerMenu('.burger', '.header__menu', '.menu__item--arrow');
    * die.burgerMenu('.burger', '.header__nav', '.menu__item--arrow', 'overlay');
    */
    // !!!
    //die.burgerMenu('.burger', '.header__nav');


    // Submenu 
    /*
    const menuArrow = document.querySelectorAll('.menu__item--arrow');
    const menuLink = document.querySelectorAll('.menu-item-has-children .menu__item--link:not([href])');
    if (menuArrow.length > 0) {
        menuArrow.forEach(el => {
            el.addEventListener('click', (e) => {
                e.target.nextElementSibling.classList.toggle('menu__submenu--show');
                e.target.classList.toggle('rotate');
            })
        });
    }
    if (menuLink.length > 0) {
        menuLink.forEach(el => {
            el.addEventListener('click', (e) => {
                e.preventDefault();
                const href = e.target.href;
                if (e.target.nextSibling) {
                    e.target.nextSibling.nextElementSibling.classList.toggle('menu__submenu--show');
                }
                if (e.target.nextElementSibling) {
                    e.target.nextElementSibling.classList.toggle('rotate');
                }

                // <a href="javascript:void(0)"
            })
        });
    }
*/



    window.onscroll = function () {

        die.toTop();

    }

    //die.spoilers();

    //video.videoPopup();

    //formsOld.form();
    //formsOld.baseInfoForm();

    const countryPhoneCodes = () => {
        const countryCodes = [
            { code: 'ua', dial_code: '+380', name: 'Ukraine' },
            { code: 'ru', dial_code: '+7', name: 'Russia' },
            { code: 'us', dial_code: '+1', name: 'United States' },
            { code: 'ca', dial_code: '+1', name: 'Canada' },
            { code: 'gb', dial_code: '+44', name: 'United Kingdom' },
            { code: 'de', dial_code: '+49', name: 'Germany' },
            { code: 'fr', dial_code: '+33', name: 'France' },
            { code: 'it', dial_code: '+39', name: 'Italy' },
            { code: 'es', dial_code: '+34', name: 'Spain' },
            { code: 'cn', dial_code: '+86', name: 'China' },
            { code: 'jp', dial_code: '+81', name: 'Japan' },
            { code: 'kr', dial_code: '+82', name: 'South Korea' },
            { code: 'in', dial_code: '+91', name: 'India' },
            { code: 'au', dial_code: '+61', name: 'Australia' },
            { code: 'br', dial_code: '+55', name: 'Brazil' },
            { code: 'mx', dial_code: '+52', name: 'Mexico' },
            { code: 'za', dial_code: '+27', name: 'South Africa' },
            { code: 'eg', dial_code: '+20', name: 'Egypt' },
            { code: 'tr', dial_code: '+90', name: 'Turkey' }
            // Додайте інші країни Європи за потреби
        ];
        // Функція для створення і заповнення select елемента
        const createCountryCodeSelect = (inputElement) => {
            const select = document.createElement('select');
            select.classList.add('country-codes');

            countryCodes.forEach(country => {
                const option = document.createElement('option');
                option.value = country.dial_code;
                option.textContent = country.code;


                if (country.code === 'ua') {
                    option.selected = true;
                    inputElement.value = country.dial_code;
                }

                select.appendChild(option);
            });

            select.addEventListener('change', (e) => {
                inputElement.value = e.target.value;
            });

            return select;
        }
        // Знаходимо всі input типу "tel" і додаємо перед ними select з кодами країн
        document.querySelectorAll('input[type="tel"]').forEach(input => {
            const wrapper = input.closest('.phone-input-wrapper');
            if (wrapper) {
                const select = createCountryCodeSelect(input);
                wrapper.insertBefore(select, input);
            }
        });
    }
    //countryPhoneCodes();


    /********************* Dynamic height header *********************/
    const heightHeader = () => {
        const header = document.querySelectorAll('.header');
        if (header) {
            let height = header[0].offsetHeight;
            document.body.style = `--header-height: ${height}px`;

            let mdQueriesArray = tech.dataMediaQueries(header, "height");

            if (mdQueriesArray && mdQueriesArray.length) {
                mdQueriesArray.forEach(mdQueriesItem => {
                    // EEvents
                    mdQueriesItem.matchMedia.addEventListener("change", function () {
                        height = document.querySelector('.header').offsetHeight;
                        document.body.style = `--header-height: ${height}px`;
                    });
                });
            }
        }
    }
    //heightHeader();






    /********************* Cookie Modals *********************/
    // Cookie Modals
    // die.cookieModal('.cookie_accept');

    //const modal = new Modal();

    let vh = window.innerHeight * 0.01;
    // Then we set the value in the --vh custom property to the root of the document
    document.documentElement.style.setProperty('--vh', `${vh}px`);

    const aTargeet = () => {
        const targets = document.querySelectorAll('[data-target="a-blank"]');
        if (targets.length > 0) {
            targets.forEach(el => {
                el.setAttribute('target', '_blank');
            });
        }
    }
    aTargeet();


    // Google maps
    const initMap = () => {
        // Styles a map in night mode
        // place_id ChIJr68EUO4zxkARH5w2ZG-axEc
        // https://maps.googleapis.com/maps/api/place/details/json?place_id=ChIJr68EUO4zxkARH5w2ZG-axEc&key=AIzaSyDOxIiFzj71a29xF3Qg5OM2WheftfpijFo
        //46.418431662491244, 30.71698709284445
        //46.418432584364034, 30.716987817677598
        let coordinates = { lat: 46.418432584364034, lng: 30.716987817677598 };
        const svgMarker = {
            path: "M15.5 0C6.95325 0 0 6.82353 0 15.2107C0 25.6195 13.871 40.9003 14.4615 41.5457C15.0163 42.152 15.9847 42.1509 16.5384 41.5457C17.129 40.9003 31 25.6195 31 15.2107C30.9998 6.82353 24.0467 0 15.5 0ZM15.5 22.8637C11.1999 22.8637 7.70164 19.4306 7.70164 15.2107C7.70164 10.9909 11.2 7.55788 15.5 7.55788C19.8 7.55788 23.2983 10.991 23.2983 15.2108C23.2983 19.4307 19.8 22.8637 15.5 22.8637Z",
            fillColor: "#4EB748",
            fillOpacity: 1,
            strokeWeight: 0,
            rotation: 0,
            //scale: 1.2,
            ///labelOrigin: new google.maps.Point(46.418432584364034, 30.716987817677598),
            anchor: new google.maps.Point(0, 30),
            scaledSize: new google.maps.Size(31, 42),



        };
        // https://mapstyle.withgoogle.com/
        const styles = [
            { elementType: "geometry", stylers: [{ color: "#212121" }] },
            { elementType: "labels.icon", stylers: [{ visibility: "off" }] },
            { elementType: "labels.text.stroke", stylers: [{ color: "#212121" }] },
            { elementType: "labels.text.fill", stylers: [{ color: "#746855" }] },
            {
                featureType: "administrative.locality",
                elementType: "labels.text.fill",
                stylers: [{ color: "#d59563" }],
            },
            /*{
                featureType: "poi",
                elementType: "labels.text.fill",
                stylers: [{ color: "#d59563" }],
            },
            {
                featureType: "poi.park",
                elementType: "geometry",
                stylers: [{ color: "#263c3f" }],
            },
            {
                featureType: "poi.park",
                elementType: "labels.text.fill",
                stylers: [{ color: "#6b9a76" }],
            },*/
            {
                featureType: "road",
                elementType: "geometry",
                stylers: [{ color: "#2C2C2C" }],
            },
            {
                featureType: "road",
                elementType: "geometry.stroke",
                stylers: [{ color: "#212121" }],
            },
            {
                featureType: "road.highway",
                elementType: "geometry",
                stylers: [{ color: "#3B3B3B" }],
            },
            {
                featureType: "road.highway",
                elementType: "geometry.stroke",
                stylers: [{ color: "#212121" }],
            },
            {
                featureType: "road",
                elementType: "labels.text.fill",
                stylers: [{ color: "#616161" }],
            },
            {
                featureType: "road.highway",
                elementType: "labels.text.fill",
                stylers: [{ color: "#616161" }],
            },

            {
                featureType: "transit",
                elementType: "geometry",
                stylers: [{ color: "#3B3B3B" }],
            },
            {
                featureType: "transit.station",
                elementType: "labels.text.fill",
                stylers: [{ color: "#d59563" }],
            },
            {
                featureType: "water",
                elementType: "geometry",
                stylers: [{ color: "#17263c" }],
            },
            {
                featureType: "water",
                elementType: "labels.text.fill",
                stylers: [{ color: "#515c6d" }],
            },
            {
                featureType: "water",
                elementType: "labels.text.stroke",
                stylers: [{ color: "#17263c" }],
            },
        ];
        let map = new google.maps.Map(document.getElementById("map"), {
            center: coordinates,
            zoom: 16,
            disableDefaultUI: true,
            mapTypeControl: false,
            /*mapTypeControlOptions: {
                mapTypeIds: ["roadmap", "satellite", "hybrid", "terrain", "styled_map"],
            },*/
            styles: styles,
        });

        const marker = new google.maps.Marker({
            position: { lat: 46.41842201984134, lng: 30.71698825265102 },
            icon: svgMarker,
            url: 'https://maps.app.goo.gl/VC4qfSMPUm1Yg6k16',
            map,
        });
        google.maps.event.addListener(marker, 'click', function () {
            //window.location.href = marker.url;
            window.open(marker.url, '_blank');
        });
    }
    if (document.getElementById("map")) {
        initMap();
    }


});

//console.log(window.navigator.userAgent.toLowerCase('/chrome/'))



/********************* Swiper Slider *********************/
/*
Основниые модули слайдера:
Navigation, Pagination, Autoplay,
EffectFade, Lazy, Manipulation
Подробнее смотри https://swiperjs.com/
*/

/*
Основниые модули слайдера:
Navigation, Pagination, Autoplay,
EffectFade, Lazy, Manipulation
Подробнее смотри https://swiperjs.com/
*/


import Swiper, { Autoplay, Navigation, Pagination, Thumbs, Controller, EffectFade } from 'swiper';
//import { exit } from 'browser-sync';
Swiper.use([Navigation, Pagination, Controller]);
//Swiper.use([Autoplay, Navigation, Pagination, Controller, EffectFade]);

const fsSl = document.querySelector('.fs__slider');
if (fsSl) {
    const countSlides = document.querySelectorAll(".fs__slide").length;
    const fsslides = new Swiper(fsSl, {
        modules: [Pagination, Autoplay],
        slidesPerView: 'auto',
        spaceBetween: 0,
        watchSlidesProgress: true,
        navigation: {
            nextEl: '.fs__next',
            prevEl: '.fs__prev',
        },
        noSwipingClass: 'swiper-no-swiping',
        noSwipingSelector: 'button',
        direction: 'horizontal',
        grabCursor: true,
        allowTouchMove: true,
        centeredSlides: true,
        mousewheel: true,
        lazy: {
            loadPrevNext: true,
        },
        disableOnInteraction: true, // stop in hover
        autoplay: {
            delay: 7000,
            disableOnInteraction: false,
        },
        pagination: {
            el: ".fs__pagination",
            clickable: true,
        },
        on: {
            slideChange() {
                let currentSlide = this.activeIndex + 1;
                document.querySelector('.fs__counter').innerHTML = `
                <span class="current">${currentSlide}</span>/<span class="total">${this.slides.length}</span>`;
            },
            init: function () {
                let currentSlide = this.activeIndex + 1;
                document.querySelector('.fs__counter').innerHTML = `
                <span class="current">${currentSlide}</span>/<span class=total">${this.slides.length}</span>`;
            }
        },
    });
}

const logoslider = document.querySelector('.logoslider__slider');
if (logoslider) {
    const bsl = new Swiper(logoslider, {
        modules: [Autoplay],
        slidesPerView: 2,
        //slidesPerGroup: 3,
        spaceBetween: 10,
        noSwiping: true,
        loop: false,
        lazy: {
            loadPrevNext: true,
        },
        navigation: {
            nextEl: '.logoslider__next',
            prevEl: '.logoslider__prev',
        },
        disableOnInteraction: true, // stop in hover
        autoplay: {
            delay: 7000,
            disableOnInteraction: false,
        },
        breakpoints: {
            540: {
                slidesPerView: 2,
                //slidesPerGroup: 3,
                spaceBetween: 10,
                centeredSlides: false,
            },
            541: {
                spaceBetween: 35,
                slidesPerView: 4,
                //slidesPerGroup: 4,
            },
            1024: {
                spaceBetween: 40,
                slidesPerView: 6,
                //slidesPerGroup: 6,
            },
        },

    });
}

setTimeout(() => {
    const photoSliders = document.querySelectorAll('.portfolio-block__photos-slider');

    if (photoSliders.length > 0) {
        photoSliders.forEach(slider => {
            new Swiper(slider, {
                slidesPerView: 1,
                spaceBetween: 0,
                nested: true,
                observer: true,
                observeParents: true,
                watchOverflow: true,
                navigation: {
                    nextEl: slider.closest('.portfolio-block__progect-media').querySelector('.portfolio-block__photos-next'),
                    prevEl: slider.closest('.portfolio-block__progect-media').querySelector('.portfolio-block__photos-prev'),
                },
                breakpoints: {
                    // Від 768px і вище показуємо 1.5 слайди
                    768: {
                        slidesPerView: 1.5,
                        spaceBetween: 0,
                        centeredSlides: false, // щоб пів слайда "виглядало" збоку
                    },
                },
            });
        });
    }

    // 2. Головний слайдер (для проектів)
    // Тут перевірка обов'язкова, бо Swiper кине помилку, якщо передати йому селектор порожнього блоку
    const projectSliderElement = document.querySelector('.portfolio-block__progect');

    if (projectSliderElement) {
        new Swiper(projectSliderElement, {
            slidesPerView: 1,
            spaceBetween: 30,
            observer: true,
            observeParents: true,
            navigation: {
                nextEl: '.portfolio-block__progect-next',
                prevEl: '.portfolio-block__progect-prev',
            },
        });
    }
}, 100);

const portfolio = document.querySelector('.portfolio__slider');
if (portfolio) {
    const portfoliolider = new Swiper(portfolio, {
        modules: [Pagination],
        spaceBetween: 30,
        loop: false,
        lazy: true,
        slidesPerView: 'auto',
        navigation: {
            nextEl: '.portfolio__next',
            prevEl: '.portfolio__prev',
        },
        pagination: {
            el: ".portfolio__pagination",
            clickable: true,
            type: 'fraction',
            formatFractionCurrent: function (number) {
                // Формат поточного слайду (01, 02 тощо)
                return number < 10 ? '0' + number : number;
            },
            formatFractionTotal: function (number) {
                // Формат загальної кількості (03)
                return number < 10 ? '0' + number : number;
            },
            renderFraction: function (currentClass, totalClass) {
                // Кастомний рендер: <span class="current">01</span>/<span class="total">03</span>
                return '<span class="' + currentClass + '"></span>' + '<svg><use xlink:href="#icon-slash"/></svg>' + '<span class="' + totalClass + '"></span>';
            },
        }
    });
}

const portfolioProgect = document.querySelectorAll('.portfolio__slide-media-slider');
if (portfolioProgect.length > 0) {
    portfolioProgect.forEach((sliders, index) => {
        new Swiper(sliders, {
            spaceBetween: 22,
            loop: false,
            //autoHeight: true,
            slidesPerView: 1.8,
            lazy: true,
            navigation: {
                nextEl: '.portfolio__slide-media-next',
                prevEl: '.portfolio__slide-media-prev',
            },

        });
    });
}

const certificatesSl = document.querySelector('.certificates__slider');
if (certificatesSl) {
    const countSlides = document.querySelectorAll(".certificates__slide").length;
    const certificatesslides = new Swiper(certificatesSl, {
        modules: [Pagination, Autoplay],
        slidesPerView: 1,
        spaceBetween: 18,
        autoHeight: false,
        watchSlidesProgress: true,
        navigation: {
            nextEl: '.certificates__next',
            prevEl: '.certificates__prev',
        },
        noSwipingClass: 'swiper-no-swiping',
        noSwipingSelector: 'button',
        direction: 'horizontal',
        grabCursor: true,
        allowTouchMove: true,
        //centeredSlides: true,
        mousewheel: true,
        lazy: {
            loadPrevNext: true,
        },
        disableOnInteraction: true, // stop in hover
        autoplay: {
            delay: 7000,
            disableOnInteraction: false,
        },
        pagination: {
            el: ".certificates__pagination",
            clickable: true,
            type: 'fraction',
            formatFractionCurrent: function (number) {
                // Формат поточного слайду (01, 02 тощо)
                return number < 10 ? '0' + number : number;
            },
            formatFractionTotal: function (number) {
                // Формат загальної кількості (03)
                return number < 10 ? '0' + number : number;
            },
            renderFraction: function (currentClass, totalClass) {
                // Кастомний рендер: <span class="current">01</span>/<span class="total">03</span>
                return '<span class="' + currentClass + '"></span>' + '<svg><use xlink:href="#icon-slash"/></svg>' + '<span class="' + totalClass + '"></span>';
            },
        },
        breakpoints: {
            540: {
                slidesPerView: 1,
                //slidesPerGroup: 1,
                //spaceBetween: 18,
                //centeredSlides: false,
            },
            541: {
                spaceBetween: 18,
                slidesPerView: 2,
                //slidesPerGroup: 2,
            },
            1024: {
                spaceBetween: 18,
                slidesPerView: 3,
                //slidesPerGroup: 3,
            },
        },

    });
}


const review = document.querySelector('.review__slider');
if (review) {
    const reviewsl = new Swiper(review, {
        modules: [Pagination, Autoplay],
        slidesPerView: 1.2,
        lazy: true,
        spaceBetween: 24,
        loop: false,
        navigation: {
            nextEl: '.review__next',
            prevEl: '.review__prev',
        },
        pagination: {
            el: ".review__pagination",
            clickable: true,
            type: 'fraction',
            formatFractionCurrent: function (number) {
                // Формат поточного слайду (01, 02 тощо)
                return number < 10 ? '0' + number : number;
            },
            formatFractionTotal: function (number) {
                // Формат загальної кількості (03)
                return number < 10 ? '0' + number : number;
            },
            renderFraction: function (currentClass, totalClass) {
                // Кастомний рендер: <span class="current">01</span>/<span class="total">03</span>
                return '<span class="' + currentClass + '"></span>' + '<svg><use xlink:href="#icon-slash"/></svg>' + '<span class="' + totalClass + '"></span>';
            },
        },
        breakpoints: {
            540: {
                slidesPerView: 1.3,
                spaceBetween: 18,
            },
            541: {
                spaceBetween: 18,
                slidesPerView: 2.5,
            },
            1024: {
                spaceBetween: 24,
                slidesPerView: 2.5,
            },
        },
    });
}